export enum TransferType {
  ROUND_TRIP = 'RoundTrip',
  DEPARTURE = 'Departure',
  RETURN = 'Return',
}
